import React from "react";
import { Header, Footer } from "@/components/site/Header";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { AIChatWidget } from "@/components/ai/AIChatWidget";
import { RiskBanner } from "@/components/site/RiskBanner";

export const PublicLayout = ({ children }) => {
  return (
    <ThemeProvider forceScope="light">
      <div className="min-h-screen flex flex-col bg-background text-foreground">
        <Header />
        <main className="flex-1 pt-16 md:pt-20 pb-16 md:pb-14">{children}</main>
        <Footer />
        <AIChatWidget />
        <RiskBanner />
      </div>
    </ThemeProvider>
  );
};
